import { useState } from 'react'

import {
  CheckBox,
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  ModalJustify,
  Row,
  ModalObservacao
} from 'components'
import {
  DeleteIcon,
  InfoIcon,
  StatusIcon,
  UploadIcon,
  ViewFileIcon
} from 'components/Icons'
import { useToggle, useFile, useModal } from 'hooks'
import moment from 'moment'
import { AnexoPendencia } from 'services/Supplier/ThirdPartyAdministration'
import { COLORS, SPACING } from 'utils'
import { Tooltip } from '@material-ui/core'
import useHandleViewFile from 'pages/Supplier/AttachDocuments/ThirdPartyAdministration/context'

interface ITablePendency {
  tableData: AnexoPendencia[]
  cdContract: string
  handleJustify: (_txt: string, _context: AnexoPendencia) => void
  handleDeleteDocument?: (_id?: number) => void
  handleUploadFile?: (_data: {
    file: File
    idMovDocumentoForAdd: number
  }) => void
}

export const TablePendency: React.FC<ITablePendency> = ({
  tableData,
  cdContract,
  handleJustify,
  handleUploadFile,
  handleDeleteDocument
}) => {
  const { handleViewFile } = useHandleViewFile()
  const { showModal: showSystemModal } = useModal()
  const [showModal, toggleModal] = useToggle()
  const [showObservaco, toggleObservacaoModal] = useToggle()
  const [txObservacao, setTxObservacao] = useState<string>('')

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)
  const [selectedJustifyDoc, setSelectedJustifyDoc] = useState<
    AnexoPendencia | undefined
  >()
  const [justificativa, setJustificativa] = useState<string>('')
  const [hasJustificationChanged, setHasJustificationChanged] = useState(false);


  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const formatDate = (date: string | Date) => {
    if (date === null)
      return '- - - - - -';

    return moment(date).format('YYYY') === '0001'
      ? '- - - - - -'
      : moment(date).format('DD/MM/YYYY')
  }

  const formatCompetencia = (competencia: string) => {
    const [year, month] = competencia.match(/[0-9]{4}|[0-9]{2}/g)

    return `${month}/${year}`
  }

  const openFileChoose = (idMovDocumento: number) => {
    document.getElementById(`file-upload-${idMovDocumento}`).click()
  }

  function onChooseFileToUpload(
    event: React.ChangeEvent<HTMLInputElement>,
    idMovDocumento: number
  ) {
    if (event.target.files[0]) {
      if (event.target.files[0].type.includes('pdf')) {
        const limitUpload = 2000000000 // 2GB

        if (event?.target?.files[0].size >= limitUpload) {
          showSystemModal({
            type: 'alert',
            message: 'Limite para o tamanho do arquivo atingido: 2GB portanto arquivo não pode ser anexado',
            hideButtonCancel: true,
            txtButtonConfirm: 'OK'
          })

          return
        }

        handleUploadFile({
          file: event.target.files[0],
          idMovDocumentoForAdd: idMovDocumento
        })

        event.target.value = ''
        return
      }

      showSystemModal({
        hideButtonCancel: true,
        message: 'Só é permitido anexar documentos em PDF.',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
    }
  }

  const handleStatus = (status: string) => {
    if (
      status === 'Green' ||
      status === 'Aprovado' ||
      status === 'Liberado' ||
      status === 'L'
    )
      return 'Aprovado'
    if (
      status === 'Yellow' ||
      status === 'Analisar' ||
      status === 'Analisando' ||
      status === 'PendenteDocumento' ||
      status === 'P'
    )
      return 'Em análise'
    if (status === 'Red' || status === 'Recusado' || status === 'B')
      return 'Reprovado'
    return 'Pendente envio'
  }

  const handleOpenJustificationModal = (row: AnexoPendencia) => {
    if (row.cdStatus === 'Recusado' && !hasJustificationChanged) {
      setJustificativa(''); 
    } else {
      setJustificativa(row.txJustificativa || ''); 
    }
    setSelectedJustifyDoc(row);
    toggleModal();
  };
  const handleSaveJustification = () => {
    setHasJustificationChanged(true);
    handleJustify(justificativa, selectedJustifyDoc);
  };

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled padding="checkbox" align="center">
                {/* <CheckBox /> */}
              </TableCellStyled>
              <TableCellStyled>Tipo Documento</TableCellStyled>
              <TableCellStyled>Contrato</TableCellStyled>
              <TableCellStyled align="center">Competencia</TableCellStyled>
              <TableCellStyled align="center">Data Anexada</TableCellStyled>
              <TableCellStyled align="center">Dias Pendentes</TableCellStyled>
              <TableCellStyled align="center">Qtd. Analises</TableCellStyled>
              <TableCellStyled align="center" padding="checkbox">
                Justificativa
              </TableCellStyled>
              <TableCellStyled align="center">Retorno Analise</TableCellStyled>
              <TableCellStyled align="center" padding="checkbox">
                Observação da Analise
              </TableCellStyled>
              <TableCellStyled align="center" padding="checkbox">
                Status
              </TableCellStyled>
              <TableCellStyled align="center">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? tableData?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : tableData
            )?.map((row, index) => (
              <TableRowStyled key={`${index}-pendencia-table-row`}>
                <TableCellStyled padding="checkbox" align="center">
                  <CheckBox
                    marginRight="auto"
                    marginLeft="auto"
                    checked={Boolean(row?.base64)}
                    disabled={['Analisar', 'Aprovado'].includes(row?.cdStatus)}
                  />
                </TableCellStyled>
                <TableCellStyled>
                  {row.txDescricaoTipo || '- - - - - -'}
                </TableCellStyled>
                <TableCellStyled>{cdContract || '- - - - - -'}</TableCellStyled>
                <TableCellStyled align="center">
                  {row?.competencia
                    ? formatCompetencia(row?.competencia?.toString())
                    : '- - - - - -'}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {formatDate(row.dtAnexado)}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {Math.abs(row.diasPendentes)}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {row.qtdAnalises || '- - - - - -'}
                </TableCellStyled>
                <TableCellStyled align="center">
                <InfoIcon
    onClick={() => handleOpenJustificationModal(row)}
    cursor="pointer"
  />
                </TableCellStyled>
                <TableCellStyled align="center">
                  {formatDate(row?.dtRetorno)}
                </TableCellStyled>
                <TableCellStyled align="center">
                  <InfoIcon
                    disabled={row?.txObservacaoAnexo === null || row?.txObservacaoAnexo.length <= 0}
                    onClick={() => {
                      setTxObservacao(row?.txObservacaoAnexo)
                      toggleObservacaoModal()
                    }}
                    cursor="pointer"
                  />
                </TableCellStyled>
                <Tooltip
                  arrow
                  placement="left"
                  title={handleStatus(row.cdStatus)}
                >
                  <TableCellStyled align="center" padding="checkbox">
                    <StatusIcon
                      value={row.cdStatus}
                      colorIcon={COLORS.gray}
                      marginLeft="auto"
                      marginRight="auto"
                    />
                  </TableCellStyled>
                </Tooltip>
                <TableCellStyled align="center">
                  <Row alignItems="center">
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(event) =>
                        onChooseFileToUpload(event, row?.idMovDocumento)
                      }
                      id={`file-upload-${row?.idMovDocumento}`}
                      style={{ display: 'none' }}
                    />
                    <UploadIcon
                      key={`${index}-upload-item`}
                      onClick={() => openFileChoose(row?.idMovDocumento)}
                      colorIcon={COLORS.black}
                      cursor="pointer"
                      disabled={
                        ['Analisar', 'Aprovado'].includes(row?.cdStatus) ||
                        Boolean(row?.base64)
                      }
                    />
                    <ViewFileIcon
                      onClick={() =>
                        handleViewFile({
                          gedExternalID: row.cdGedExternalId,
                          local: { base64: row.base64, filename: row.filename }
                        })
                      }
                      marginLeft={SPACING.spacing15}
                      marginRight={SPACING.spacing15}
                      cursor="pointer"
                      disabled={
                        ['Pendente', null].includes(row?.cdStatus) &&
                        !row?.base64
                      }
                      colorIcon={COLORS.black}
                    />
                    <DeleteIcon
                      onClick={() => handleDeleteDocument(row?.idMovDocumento)}
                      disabled={['Aprovado'].includes(row?.cdStatus) || !row?.base64}
                      cursor="pointer"
                    />
                  </Row>
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        typeFooter="offline"
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <ModalJustify
        showModal={showModal}
        cdStatus={selectedJustifyDoc?.cdStatus}
        defaultValue={selectedJustifyDoc?.txJustificativa}
        value={justificativa}
        onChangeText={setJustificativa}
        toggleModal={toggleModal}
        handleJustify={handleSaveJustification}
      />
      <ModalObservacao
        showModal={showObservaco}
        toggleModal={toggleObservacaoModal}
        txObservacao={txObservacao}
      />
    </>
  )
}
